import React from "react";
import {
  StyledMatchPromo,
  StyledMatchPromoDescription,
  StyledMatchPromoTitle,
} from "./StyledMatchPromo";
import MatchPromoButton from "./MatchPromoButton/MatchPromoButton";

function MatchPromo({ headline, description, callToAction1, callToAction2 }) {
  return (
    <StyledMatchPromo className="mls-c-match-promo">
      {headline && <StyledMatchPromoTitle>{headline}</StyledMatchPromoTitle>}
      {description && (
        <StyledMatchPromoDescription>{description}</StyledMatchPromoDescription>
      )}
      {callToAction1 && <MatchPromoButton callToAction={callToAction1} />}
      {callToAction2 && <MatchPromoButton callToAction={callToAction2} />}
    </StyledMatchPromo>
  );
}

export default MatchPromo;
